<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faCircleDot"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">
                Overview
                <font-awesome-icon widthAuto :icon="faTelescope"></font-awesome-icon>
            </h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                Upload a group of contacts you’d like to store and message within Voxie. Every piece of data you upload
                about a contact as a column header will be stored as a custom variable and can be later used to filter
                or target that contact.
            </p>
            <a
                href="https://explore.voxie.com/voxiesupport/contact-imports"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-sans font-normal text-sky-500 underline lg:text-base"
            >
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2" :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup>
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong, faCircleDot } from '@fortawesome/pro-solid-svg-icons';
import { faTelescope } from '@fortawesome/pro-regular-svg-icons';
</script>
